import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet, NavLink } from "react-router-dom";
import "./AdminLayout.css";

const ADMIN_MENU = [
  { label: "Dashboard", permission: "*", path: "/admin/dashboard", icon: "📊", color: "#6366f1" },
  { label: "Courses", permission: "courses", path: "/admin/courses", icon: "📚", color: "#6366f1" },
  { label: "Certificates", permission: "certificates", path: "/admin/certificates", icon: "📜", color: "#8b5cf6" },
  { label: "Partners", permission: "partners", path: "/admin/partners", icon: "🤝", color: "#ec4899" },
  { label: "Enroll Form", permission: "enroll_form", path: "/admin/enroll", icon: "✍️", color: "#f43f5e" },
  { label: "Event Poster", permission: "event_poster", path: "/admin/event-poster", icon: "🖼️", color: "#3b82f6" },
  { label: "User Event", permission: "user_event", path: "/admin/userEvent", icon: "👤", color: "#06b6d4" },
  { label: "Being a Partner", permission: "being_partner", path: "/admin/adminform", icon: "💼", color: "#10b981" },
  { label: "Contact Form", permission: "get_in_touch_messages", path: "/admin/messages", icon: "📧", color: "#f59e0b" },
  { label: "IV Forms", permission: "iv_forms", path: "/admin/ivform", icon: "🗒️", color: "#84cc16" },
  { label: "Product Details", permission: "product_details", path: "/admin/products", icon: "📦", color: "#ef4444" },
  { label: "Product Quotes", permission: "product_quotes", path: "/admin/product-quotes", icon: "💰", color: "#fbbf24" },
  { label: "Quiz Scores", permission: "quiz_scores", path: "/admin/quiz", icon: "🏆", color: "#d946ef" },
  { label: "Quiz Questions", permission: "quiz_questions", path: "/admin/quiz-questions", icon: "❓", color: "#4f46e5" },
  { label: "Manage Images", permission: "gallery", path: "/admin/gallery", icon: "🖼️", color: "#0ea5e9" },
  { label: "Stats", permission: "stats", path: "/admin/stats", icon: "📊", color: "#22c55e" },
  { label: "Reviews", permission: "reviews", path: "/admin/reviews", icon: "⭐", color: "#fb923c" },
  { label: "Add Admin", permission: "admin.manage", path: "/admin/add-admin", icon: "➕", color: "#475569" },
  { label: "View Admins", permission: "admin-manage", path: "/admin/view-admins", icon: "👀", color: "#64748b" },
  { label: "Career Applications", permission: "career_applications", path: "/admin/careers", icon: "📄", color: "#1e293b" },
  { label: "Job Postings", permission: "job_postings", path: "/admin/job-postings", icon: "🏢", color: "#334155" },
  { label: "Franchise Applications", permission: "franchise_applications", path: "/admin/franchises", icon: "🏪", color: "#0f172a" },
  { label: "Offers", permission: "offers", path: "/admin/offers", icon: "🎟️", color: "#7c3aed" },
  { label: "Consultation Requests", permission: "consultations", path: "/admin/consultations", icon: "👨‍🏫", color: "#2563eb" },
  { label: "About Us Content", permission: "about_content", path: "/admin/about-content", icon: "📖", color: "#0891b2" },
  { label: "Legal Content", permission: "legal_content", path: "/admin/legal-content", icon: "⚖️", color: "#ef4444" },
];

const AdminLayout = () => {
  const [admin, setAdmin] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("adminInfo") || "null");
    if (!stored || !stored.token) {
      navigate("/admin");
      return;
    }

    const user = stored.user || stored.admin; // Handle different formats
    if (!user) {
        // Fallback or fetch profile
        setAdmin({ name: "Admin", role: "Operator" });
    } else {
      setAdmin(user);
    }
  }, [navigate]);

  if (!admin) return null;

  const hasAll = admin.permissions && (admin.permissions.includes("*") || admin.role === "superAdmin");
  const visibleMenu = ADMIN_MENU.filter((item) => {
    if (hasAll) return true;
    return admin.permissions && admin.permissions.includes(item.permission);
  });

  const handleLogout = () => {
    localStorage.removeItem("adminInfo");
    navigate("/admin");
  };

  return (
    <div className="admin-layout-container">
      <aside className="admin-layout-sidebar">
        <div className="ap-logo-section">
          <img src="/logo.png" alt="FlyTutor" />
          <span>admin</span>
        </div>

        <nav className="sidebar-nav">
          {visibleMenu.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) => `nav-item-link ${isActive ? "active" : ""}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <button className="logout-btn-premium" onClick={handleLogout}>
          Terminate Session <span>🚪</span>
        </button>
      </aside>

      <main className="admin-layout-main">
        <header className="ap-top-nav">
          <div className="ap-breadcrumb">
            Dashboard / {location.pathname.split("/").pop().charAt(0).toUpperCase() + location.pathname.split("/").pop().slice(1)}
          </div>
          <div className="ap-status-badge">System Optimized</div>
        </header>
        <div className="admin-page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
